import { makeStyles } from '@material-ui/core';

import {
  boxShadow,
  dangerColor,
  defaultFont,
  drawerWidth,
  infoColor,
  primaryBoxShadow,
  primaryColor,
  roseColor,
  successColor,
  transition,
  warningColor,
} from '../../assets/jss/material-dashboard-pro-react';
import THEME from '../../constants/theme';

export const useSidebarStyle = makeStyles(theme => ({
  drawerPaper: {
    border                      : 'none',
    position                    : 'fixed',
    top                         : '0',
    bottom                      : '0',
    left                        : '0',
    zIndex                      : '1032',
    transitionProperty          : 'top, bottom, width',
    transitionDuration          : '.2s, .2s, .35s',
    transitionTimingFunction    : 'linear, linear, ease',
    // overflow: 'auto',
    boxShadow                   : '1px 0px 0px #cdcfd5',
    width                       : drawerWidth,
    [theme.breakpoints.up('md')]: {
      width    : drawerWidth,
      boxShadow: '1px 0px 0px #cdcfd5',
      position : 'fixed',
      height   : '100%',
    },
    [theme.breakpoints.down('sm')]: {
      width       : drawerWidth,
      boxShadow   : '1px 0px 0px #cdcfd5',
      position    : 'fixed',
      display     : 'block',
      top         : '0',
      height      : '100vh',
      right       : '0',
      left        : 'auto',
      zIndex      : '1032',
      visibility  : 'visible',
      overflowY   : 'visible',
      borderTop   : 'none',
      textAlign   : 'left',
      paddingRight: '0px',
      paddingLeft : '0',
      transform   : `translate3d(${drawerWidth}px, 0, 0)`,
      ...transition,
    },
    '&:before,&:after': {
      position: 'absolute',
      zIndex  : '3',
      width   : '100%',
      height  : '100%',
      content : '""',
      display : 'block',
      top     : '0',
    },
  },
  blackBackground: {
    color    : '#FFFFFF',
    '&:after': {
      background: '#000',
      opacity   : '.8',
    },
  },
  blueBackground: {
    color    : '#FFFFFF',
    '&:after': {
      background: THEME.primary,
      opacity   : '.93',
    },
  },
  whiteBackground: {
    color    : '#3C4858',
    '&:after': {
      background: '#FFFFFF',
      opacity   : '.93',
    },
  },
  whiteAfter: {
    '&:after': {
      backgroundColor: 'hsla(0,0%,71%,.3) !important',
    },
  },
  whiteBeforeLink: {
    '&:before': {
      content        : '""',
      position       : 'absolute',
      top            : '-8px',
      height         : '1px',
      right          : '15px',
      width          : 'calc(100% - 30px)',
      backgroundColor: 'hsla(0,0%,71%,.3) !important',
    },
  },
  logo: {
    padding       : '15px 0px',
    margin        : '0',
    display       : 'flex',
    position      : 'relative',
    justifyContent: 'center',
    zIndex        : '4',
  },
  logoMini: {
    transition : 'all 300ms linear',
    opacity    : 1,
    float      : 'left',
    textAlign  : 'center',
    width      : '30px',
    display    : 'inline-block',
    maxHeight  : '30px',
    marginLeft : '22px',
    marginRight: '18px',
    marginTop  : '7px',
    color      : 'inherit',
  },
  logoNormal: {
    ...defaultFont,
    transition         : 'all 300ms linear',
    display            : 'block',
    opacity            : '1',
    transform          : 'translate3d(0px, 0, 0)',
    textTransform      : 'uppercase',
    padding            : '5px 0px',
    fontSize           : '18px',
    whiteSpace         : 'nowrap',
    fontWeight         : '400',
    lineHeight         : '30px',
    overflow           : 'hidden',
    '&,&:hover,&:focus': {
      color: 'inherit',
    },
  },
  img: {
    width        : '35px',
    verticalAlign: 'middle',
    border       : '0',
  },
  list: {
    marginTop         : '15px',
    paddingLeft       : '0',
    paddingTop        : '0',
    paddingBottom     : '0',
    marginBottom      : '0',
    listStyle         : 'none',
    color             : 'inherit',
    '&:before,&:after': {
      display: 'table',
      content: '" "',
    },
    '&:after': {
      clear: 'both',
    },
  },
  item: {
    color         : 'inherit',
    position      : 'relative',
    display       : 'block',
    textDecoration: 'none',
    margin        : '0',
    padding       : '0',
  },
  itemLink: {
    paddingLeft    : '10px',
    paddingRight   : '10px',
    transition     : 'all 300ms linear',
    margin         : '10px 15px 0',
    borderRadius   : '3px',
    display        : 'flex',
    flexDirection  : 'row',
    padding        : '10px 15px',
    backgroundColor: 'transparent',
    ...defaultFont,
    width          : 'auto',
    '&:hover'      : {
      outline        : 'none',
      backgroundColor: 'rgba(200, 200, 200, 0.2)',
      boxShadow      : 'none',
    },
    '&,&:hover,&:focus': {
      color: 'inherit',
    },
  },
  itemIcon: {
    color  : 'inherit',
    float  : 'left',
    opacity: '0.8',
  },
  itemText: {
    color     : 'inherit',
    ...defaultFont,
    margin    : '0',
    lineHeight: '30px',
    fontSize  : '14px',
    fontWeight: '500',
    transform : 'translate3d(0px, 0, 0)',
    opacity   : '1',
    transition: 'transform 300ms ease 0s, opacity 300ms ease 0s',
    position  : 'relative',
    display   : 'block',
    height    : 'auto',
    whiteSpace: 'nowrap',
  },
  purple: {
    '&,&:hover,&:focus': {
      color          : '#FFFFFF',
      backgroundColor: primaryColor,
      ...primaryBoxShadow,
    },
  },
  blue: {
    '&,&:hover,&:focus': {
      color          : '#FFFFFF',
      backgroundColor: infoColor,
      boxShadow      :
        '0 12px 20px -10px rgba(0,188,212,.28), 0 4px 20px 0 rgba(0,0,0,.12), 0 7px 8px -5px rgba(0,188,212,.2)',
    },
  },
  green: {
    '&,&:hover,&:focus': {
      color          : '#FFFFFF',
      backgroundColor: successColor,
      boxShadow      :
        '0 12px 20px -10px rgba(76,175,80,.28), 0 4px 20px 0 rgba(0,0,0,.12), 0 7px 8px -5px rgba(76,175,80,.2)',
    },
  },
  orange: {
    '&,&:hover,&:focus': {
      color          : '#FFFFFF',
      backgroundColor: warningColor,
      boxShadow      :
        '0 12px 20px -10px rgba(255,152,0,.28), 0 4px 20px 0 rgba(0,0,0,.12), 0 7px 8px -5px rgba(255,152,0,.2)',
    },
  },
  red: {
    '&,&:hover,&:focus': {
      color          : '#FFFFFF',
      backgroundColor: dangerColor,
      boxShadow      :
        '0 12px 20px -10px rgba(244,67,54,.28), 0 4px 20px 0 rgba(0,0,0,.12), 0 7px 8px -5px rgba(244,67,54,.2)',
    },
  },
  white: {
    '&,&:hover,&:focus': {
      color          : '#3C4858',
      backgroundColor: '#FFFFFF',
      boxShadow      : '0 4px 20px 0 rgba(0,0,0,.14), 0 7px 10px -5px rgba(60,72,88,.4)',
    },
  },
  rose: {
    '&,&:hover,&:focus': {
      color          : '#FFFFFF',
      backgroundColor: roseColor,
      boxShadow      : '0 4px 20px 0 rgba(0,0,0,.14), 0 7px 10px -5px rgba(233,30,99,.4)',
    },
  },
  sidebarWrapper: {
    position                : 'relative',
    height                  : 'calc(100vh - 75px)',
    overflow                : 'auto',
    width                   : '260px',
    zIndex                  : '4',
    overflowScrolling       : 'touch',
    transitionProperty      : 'top, bottom, width',
    transitionDuration      : '.2s, .2s, .35s',
    transitionTimingFunction: 'linear, linear, ease',
    color                   : 'inherit',
    paddingBottom           : '30px',
  },
}));
